import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const PaymentHistoryPage = lazy(() => import("./PaymentHistoryPage"));

const PaymentHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <PaymentHistoryPage />
    </Suspense>
  );
};

export default PaymentHistoryPageLazy;
